export default {"src":"/_next/static/media/chademo.91ce7157.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};